var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipboard = function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M9.333 2.333c.543 0 .814 0 1.037.06a1.75 1.75 0 0 1 1.237 1.237c.06.223.06.494.06 1.037v5.366c0 .98 0 1.47-.191 1.845a1.75 1.75 0 0 1-.765.765c-.374.19-.864.19-1.844.19H5.133c-.98 0-1.47 0-1.844-.19a1.75 1.75 0 0 1-.765-.765c-.19-.374-.19-.865-.19-1.845V4.667c0-.543 0-.814.059-1.037A1.75 1.75 0 0 1 3.63 2.393c.223-.06.494-.06 1.037-.06M5.6 3.5h2.8c.327 0 .49 0 .615-.064a.6.6 0 0 0 .255-.255c.063-.124.063-.288.063-.614V2.1c0-.327 0-.49-.063-.615a.6.6 0 0 0-.255-.255c-.125-.063-.288-.063-.615-.063H5.6c-.327 0-.49 0-.615.063a.6.6 0 0 0-.255.255c-.063.125-.063.288-.063.615v.467c0 .326 0 .49.063.614.056.11.145.2.255.255.125.064.288.064.615.064"
  })));
};
export default SvgClipboard;